// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1v-6";
export var headerCell = "_1v-2";
export var rowWrapper = "_1v-4";
export var stickyAggregationCell = "_1v-a";
export var stickyAggregationRow = "_1v-7";
export var stickyColumnCell = "_1v-9";
export var stickyColumnHeaderCell = "_1v-8";
export var table = "_1v-1";
export var virtualRowWrapper = "_1v-5";
export var virtualTableContainer = "_1v-0";
export var white = "_1v-3";